import React from 'react'
import UseHTML from '../../../components/hook/UseHTML';

const Player = props => {
    const {content, title} = props;
    return (
        <article className='player'>
            <div> 
                <h1>{title}</h1>
                <UseHTML html={content}/> 
            </div>
        </article>
    )
}

export default Player
